(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
      
    $(document).ready(function () {
  document.addEventListener('DOMContentLoaded', function () {
    $(".tabs_link").on("click", function () {
      $(".tabs_link, .tabs_content").removeClass("active");
      $(this).addClass("active");
      $(this).next(".tabs_content").addClass("active");
    });
  });
  function tabSlider() {
    $('.tabs .product-grid.slick-initialized ').slick('unslick');
    $('.tabs .product-grid ').slick({
      dots: true,
      prevArrow: "<button type='button' aria-label='Previous Slide' class='slick-prev pull-left'><svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.5 24.5C0.5 11.5213 11.0213 1 24 1C36.9787 1 47.5 11.5213 47.5 24.5C47.5 37.4787 36.9787 48 24 48C11.0213 48 0.5 37.4787 0.5 24.5Z' stroke='#0C0C0C'/><path d='M32 23.5H19.83L25.42 17.91L24 16.5L16 24.5L24 32.5L25.41 31.09L19.83 25.5H32V23.5Z' fill='#0C0C0C'/></svg></button>",
      nextArrow: "<button type='button' aria-label='Next Slide' class='slick-next pull-right'><svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.5 24.5C0.5 11.5213 11.0213 1 24 1C36.9787 1 47.5 11.5213 47.5 24.5C47.5 37.4787 36.9787 48 24 48C11.0213 48 0.5 37.4787 0.5 24.5Z' stroke='#0C0C0C'/><path d='M24 16.5L22.59 17.91L28.17 23.5H16V25.5H28.17L22.59 31.09L24 32.5L32 24.5L24 16.5Z' fill='#0C0C0C'/></svg></button>",
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true
          }
        }
      ]
    });
  }
  $("#tabs").tabs({
    create: function (event, ui) {
  
      tabSlider()
  
    },
    activate: function (event, ui) {
  
      tabSlider()
  
    }
  });
  function updateRatioPercent() {
    if ($(window).width() <= 749) {
      $(".tabs-section #tabs .grid__item .product-card-wrapper .card--media .card__inner").css("--ratio-percent", "70%");
    }
  }
  updateRatioPercent();
  $(window).resize(function () {
    updateRatioPercent();
  });
  
  const runOnDomReady = (callback) => {
    return document.addEventListener("DOMContentLoaded", callback);
  };
  const initSlider = (identifier, config, breakpoint) => {
      if (breakpoint) {
          const runOnMatch = (media) => {
              config.init = false;
              const slider = new Swiper(identifier, config);
              if (media.matches) {
                  slider.init();
              } else {
                  slider.destroy();
              }
          };
          const media = window.matchMedia(
              `only screen and (${breakpoint >= 0 ? "min" : "max"}-width: ${
              breakpoint >= 0 ? breakpoint : breakpoint * -1
              }px)`
          );
          runOnMatch(media);
          window.addEventListener("resize", () => {
              runOnMatch(media);
          });
          media.addEventListener("change", runOnMatch);
      } else {
          new Swiper(identifier, config);
      }
  };




}); 
  
  } catch(e) { console.error(e); }
})();
})();
